<div
  class="container"
  [ngStyle]="{ 'background-image': 'url(\'' + service.photoUrl + '\')' }"
>
  <p>{{ service.title }}</p>
</div>
